<template>
</template>

<script>
  import EventBus from '@/lib/event-bus'
  import swal from 'sweetalert2'

  export default {
    data () {
      return {
        swalErrorData: this.initialSwalErrorData()
      }
    },
    mounted () {
      EventBus.$on('ERROR', (data) => {
        swal({
          ...this.initialSwalErrorData(),
          ...data
        })
      })
    },
    methods: {
      initialSwalErrorData () {
        return {
          type: 'error',
          text: '',
          position: 'top',
          customClass: this.$style.customMargin,
          confirmButtonText: 'DISMISS',
          confirmButtonColor: '#f0415a',
          showCloseButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false
        }
      }
    }
  }

</script>
<style module lang="less" src="./error-message-modal.less"></style>



// WEBPACK FOOTER //
// error-message-modal.vue?31306ac4